import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { FormulationCollectionItem } from "@/types/formulation-collection.types";

export type FormulationCollectionStoreState = FormulationCollectionItem[];

const INITIAL_STATE: FormulationCollectionStoreState = [];

const formulationCollectionSlice = createSlice({
    name: "formulation-collection",
    initialState: INITIAL_STATE,
    reducers: {
        addItem: (state, action: PayloadAction<FormulationCollectionItem>) => {
            if (state.find((item) => item.name === action.payload.name)) {
                console.error(
                    `Cannot add ${action.payload.name} to collection as item with this name is already present`
                );
                return;
            }
            state.push(action.payload);
        },
        removeItem: (state, action: PayloadAction<FormulationCollectionItem>) => {
            return state.filter((collectionItem) => collectionItem.name !== action.payload.name);
        },
        emptyCollection: () => [],
    },
});

export const { addItem, removeItem, emptyCollection } = formulationCollectionSlice.actions;
export const formulationCollectionReducer = formulationCollectionSlice.reducer;
